const HPRoles = {
    COPO_COMPANY_ADMIN: {
        roleId: 16,
        displayName: 'Company Admin',
        Name: 'COPO_COMPANY_ADMIN',
        rank: 1,
        isAdmin: true,
        isManager: false,
    },
    COPO_COMPANY_MGR: {
        roleId: 17,
        displayName: 'Company Manager',
        Name: 'COPO_COMPANY_MGR',
        rank: 1,
        isAdmin: false,
        isManager: true,
    },
    COPO_ADMIN: {
        roleId: 7,
        displayName: 'Office Admin',
        Name: 'COPO_ADMIN',
        rank: 2,
        isAdmin: true,
        isManager: false,
    },
    COPO_MGR: {
        roleId: 8,
        displayName: 'Office Manager',
        Name: 'COPO_MGR',
        rank: 2,
        isAdmin: false,
        isManager: true,
    },
    COPO_PROJECT_REP: {
        roleId: 11,
        displayName: 'Project Sales Rep',
        Name: 'COPO_PROJECT_REP',
        rank: 3,
        isAdmin: false,
        isManager: false,
    },    
    COPO_REP: {
        roleId: 9,
        displayName: 'Sales Rep',
        Name: 'COPO_REP',
        rank: 3,
        isAdmin: false,
        isManager: false,
    },
    COPO_LIMITED_REP: {
        roleId: 14,
        displayName: 'Limited Sales Rep',
        Name: 'COPO_LIMITED_REP',
        rank: 3,
        isAdmin: false,
        isManager: false,
    },
    LACounty: {
        roleId: 101,
        displayName: 'LACounty',
        Name: 'LACounty',
        rank: 4,
        isAdmin: false,
        isManager: false,
    },
    COPO_RAEMPLOYEE: {
        roleId: 10,
        displayName: 'RA Employee',
        Name: 'COPO_RAEMPLOYEE',
        rank: 5,
        isAdmin: false,
        isManager: false,
    },
};

export default HPRoles;




// WEBPACK FOOTER //
// ./src/app/config/app.roles.config.js